import { render, staticRenderFns } from "./CardDetailsForm.vue?vue&type=template&id=0d432ede&scoped=true&"
import script from "./CardDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./CardDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./CardDetailsForm.vue?vue&type=style&index=0&id=0d432ede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d432ede",
  null
  
)

export default component.exports